var _path, _path2, _path3;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSuitcase = function SvgSuitcase(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 19C2 16.2386 4.23858 14 7 14H41C43.7614 14 46 16.2386 46 19V37C46 39.7614 43.7614 42 41 42H7C4.23858 42 2 39.7614 2 37V19ZM7 18C6.44772 18 6 18.4477 6 19V37C6 37.5523 6.44772 38 7 38H41C41.5523 38 42 37.5523 42 37V19C42 18.4477 41.5523 18 41 18H7Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 16C9 14.8954 9.89543 14 11 14H37C38.1046 14 39 14.8954 39 16V40C39 41.1046 38.1046 42 37 42H11C9.89543 42 9 41.1046 9 40V16ZM13 18V38H35V18H13Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 11C14 8.23858 16.2386 6 19 6H29C31.7614 6 34 8.23858 34 11V16C34 17.1046 33.1046 18 32 18H16C14.8954 18 14 17.1046 14 16V11ZM19 10C18.4477 10 18 10.4477 18 11V14H30V11C30 10.4477 29.5523 10 29 10H19Z",
    fill: "black"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSuitcase, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/suitcase.fd27eed4.svg";
export { ForwardRef as ReactComponent };